<template>
<div class="chapter">
<div class="inner_page">
<div>
<p><span epub:type="pagebreak" id="page9" title="9"></span></p>
<p class="tp4">PART I</p>
<p class="tp5" id="_idParaDest-4"><a id="_idTextAnchor111"></a>Asia</p>
<p class="body"><span epub:type="pagebreak" id="page10" title="10"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07pt1.vue?108c7673